import { useEffect, useState } from 'react';
import '@material/web/button/filled-button.js';
import '@material/web/icon/icon.js';
import './GlobalErrorModal.css';

// Errori interni di Firestore/IndexedDB (es. il browser che chiude la cache in
// background): li gestisce dataService con la copia locale, la finestra bloccante
// servirebbe solo a spaventare.
const isStorageError = (msg) =>
    /FIRESTORE .*INTERNAL ASSERTION|IndexedDB|IDBDatabase|in-progress transaction|Indexed Database/i.test(String(msg || ''));

export default function GlobalErrorModal() {
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const handleGlobalError = (event) => {
            if (event.target && (event.target.tagName === 'IMG' || event.target.tagName === 'SCRIPT' || event.target.tagName === 'LINK')) {
                return;
            }

            console.error("Global Error Caught:", event);
            const msg = event.message || event.error?.message || (typeof event === 'string' ? event : "Si è verificato un errore imprevisto.");
            if (isStorageError(msg)) return;
            setErrorMessage(msg);
            setHasError(true);
        };

        const handlePromiseRejection = (event) => {
            console.error("Unhandled Promise Rejection Caught:", event.reason);
            if (event.reason && event.reason.name === 'AbortError') return;
            if (isStorageError(event.reason?.message || event.reason)) return;

            setErrorMessage(event.reason?.message || "Errore di connessione o risorsa non trovata.");
            setHasError(true);
        };

        const handleCustomAppError = (event) => {
            setErrorMessage(event.detail || "Si è verificato un errore nell'applicazione.");
            setHasError(true);
        };

        window.addEventListener('error', handleGlobalError, true);
        window.addEventListener('unhandledrejection', handlePromiseRejection, true);
        window.addEventListener('app-error', handleCustomAppError, true);

        return () => {
            window.removeEventListener('error', handleGlobalError, true);
            window.removeEventListener('unhandledrejection', handlePromiseRejection, true);
            window.removeEventListener('app-error', handleCustomAppError, true);
        };
    }, []);

    if (!hasError) return null;

    return (
        <div className="global-error-overlay">
            <div className="global-error-modal">
                <div className="global-error-icon">
                    <span className="material-symbols-rounded filled" style={{ fontSize: '48px', color: 'var(--md-sys-color-error)' }}>
                        warning
                    </span>
                </div>
                <h2>Oops! Qualcosa è andato storto.</h2>
                <p>{errorMessage}</p>
                <md-filled-button 
                    onClick={() => window.location.reload()}
                    aria-label="Aggiorna la pagina"
                >
                    <md-icon slot="icon">
                        <span className="material-symbols-rounded">refresh</span>
                    </md-icon>
                    Aggiorna la pagina
                </md-filled-button>
            </div>
        </div>
    );
}
